import type { ApiError, GameState } from "../worker/lib/types";
import type { Guess } from "../worker/lib/game";
import { getInitData } from "./telegram";

export type { ApiError, GameState, GroupEntry, MeStats } from "../worker/lib/types";
export type { Guess } from "../worker/lib/game";

export class ApiFailure extends Error {
  constructor(
    public readonly code: ApiError["error"] | "network",
    public readonly status: number,
    public readonly guess?: Guess,
  ) {
    super(code);
  }
}

async function call<T>(path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api/contexto${path}`, {
      method: "POST",
      headers: { "content-type": "application/json", "x-telegram-init-data": getInitData() },
      body: JSON.stringify(body ?? {}),
    });
  } catch {
    throw new ApiFailure("network", 0);
  }
  if (!res.ok) {
    const err = (await res.json().catch(() => ({ error: "server_error" }))) as ApiError;
    throw new ApiFailure(err.error ?? "server_error", res.status, err.guess);
  }
  return (await res.json()) as T;
}

export const api = {
  state: () => call<GameState>("/state"),
  guess: (word: string) => call<GameState>("/guess", { word }),
  tip: () => call<GameState>("/tip"),
  giveUp: () => call<GameState>("/giveup"),
};
